module.exports = __webpack_public_path__ + "media/images/room_monitor/washing-476a79792d9c039313805eb28c6f0490.gif";